module.exports = __webpack_public_path__ + "static/img/button1.ec3a22b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/button1.png
// module id = 5bbK
// module chunks = 1